import React, { useRef, useEffect, useState } from 'react';

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  Checkbox as CheckboxUI,
} from '@material-ui/core';
import { useField } from '@unform/core';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { canURL } from '~/helpers';

function CheckboxLocal({
  name,
  label,
  getValue,
  checked,
  serialize,
  disabled,
  ...rest
}) {
  const inputRef = useRef(null);
  const permission = isEqual(canURL(), { read: true });

  const [check, setCheck] = useState(false);

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);

  function handleChangeValue() {
    inputRef.current.value = serialize(!check);
    setCheck(!check);

    getValue(serialize(!check));
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    const defCheck = defaultValue === 'S' || defaultValue === 1;
    setCheck(defCheck);
  }, []);

  useEffect(() => {
    if (checked) {
      setCheck(true);
      inputRef.current.value = true;
      getValue(true);
    } 
    else { // TESTE
      setCheck(false);
      inputRef.current.value = false;
      getValue(false);
    }

  }, [checked]);

  useEffect(() => {
    if (disabled) clearError();
  }, [disabled]);

  return (
    <FormControl style={{ width: '100%', marginBottom: 0 }}>
      <FormControlLabel
        control={
          <CheckboxUI
            ref={inputRef}
            onChange={handleChangeValue}
            checked={check}
          />
        }
        label={label}
        error={!!error}
        {...rest}
        disabled={permission || disabled}
        onFocus={clearError}
      />

      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

CheckboxLocal.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  checked: PropTypes.bool,
  serialize: PropTypes.func,
  disabled: PropTypes.bool,
};

CheckboxLocal.defaultProps = {
  getValue: () => {},
  checked: false,
  serialize: (value) => value,
  disabled: false,
};

export default CheckboxLocal;
